import { computed } from 'vue'
import { useRoute } from 'vue-router'

const TRUE_VALUES = ['true', '1', 'yes', 'on']

function parseBool(value: string | null): boolean {
  if (!value) return false
  return TRUE_VALUES.includes(value.toLowerCase())
}

export function usePluginParams() {
  const route = useRoute()
  const params = computed(() => {
    const q = route.query as Record<string, string>
    const reservationIdRaw = q.reservation_id ?? null
    const reservationId =
      reservationIdRaw != null && reservationIdRaw !== ''
        ? parseInt(reservationIdRaw, 10)
        : null
    return {
      facilitySlug: (route.params.facilitySlug as string) ?? '',
      branchId: q.branch_id ? String(q.branch_id) : null,
      serviceId: q.service_id ? String(q.service_id) : null,
      readonly: parseBool(q.readonly ?? null),
      source: q.source ?? 'plugin',
      css: q.css ?? null,
      theme: q.theme ?? null,
      lang: q.lang ?? null,
      settingsBase64: q.s ?? null,
      zdNumber: q.number ?? null,
      zdPassword: q.password ?? null,
      zdPrice: q.zd_price ? Number(q.zd_price) : null,
      zdPaid: parseBool(q.zd_paid ?? null),
      reservationId: Number.isFinite(reservationId) ? reservationId : null,
      facilitySlugFromQuery: q.facility_slug ?? null,
      initialUrl: q.initial_url ?? null,
      name: (q.name ?? '').trim() || null,
      surname: (q.surname ?? '').trim() || null,
      email: (q.email ?? '').trim() || null,
      phone: (q.phone ?? '').trim() || null,
    }
  })
  return params
}
